import React from 'react';
import ProjectListPage, {ProjectListPageQuery} from './ProjectListPage';
import {ForecastQueryRenderer} from '../../../../ForecastQueryRenderer';
import {Query, isQueryInRelayStore} from '../../../shared/util/cache/RelayQueryCache';
import {isClientUser} from '../../../shared/util/PermissionsUtil';

export const shouldExcludeDoneOrHalted = (): boolean => {
	// Work-around to avoid race-condition. See RelayQuerycache.ts for extended documentation.
	if (!isQueryInRelayStore(Query.OverviewProjects)) {
		// If either Done or Halted is the expanded category, don't use lazy pattern.
		const expansionMapString = localStorage.getItem('projects-page-section-expanded-map');
		if (expansionMapString) {
			const expansionMap = new Map(JSON.parse(expansionMapString));
			if (expansionMap.get('DONE') || expansionMap.get('HALTED')) {
				return false;
			}
		}
		return true;
	}

	return false;
};

type ProjectListPageQueryWrapperProps = {
	buyNowTime: string;
};
export const ProjectListPageQueryWrapper = ({buyNowTime}: ProjectListPageQueryWrapperProps): JSX.Element => {
	const excludeDoneOrHalted = shouldExcludeDoneOrHalted();
	const excludeGroupProjectsFromProjectConnection = !isClientUser();
	return (
		<ForecastQueryRenderer
			key="query-render-overviewProjects"
			query={ProjectListPageQuery}
			fetchPolicy="store-or-network"
			variables={{
				excludeDoneOrHalted,
				excludeGroupProjectsFromProjectConnection,
			}}
			render={(relayProps, retry) => {
				return (
					<ProjectListPage
						retry={retry}
						{...relayProps}
						buyNowTime={buyNowTime}
						excludeDoneOrHalted={excludeDoneOrHalted}
					/>
				);
			}}
		/>
	);
};
